import { render } from "./CloseSvg.vue?vue&type=template&id=169ec3fd&scoped=true"
const script = {}

import "./CloseSvg.vue?vue&type=style&index=0&id=169ec3fd&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169ec3fd"]])

export default __exports__